module.exports = __webpack_public_path__ + "media/investors/headshot-45a797af.png";